import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { LuDownload } from "react-icons/lu";
import "./PoliciesPage.style.css";

const PoliciesPage = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  const policies = [
    {
      name: { tr: "Çevre, Enerji ve Su Politikası", en: "Environment, Energy and Water Policy" },
      href: { tr: "/sustainability/environment-and-energy-policy", en: "/sustainability/environment-and-energy-policy" }
    },
    {
      name: { tr: "İklim Değişikliği Politikası", en: "Climate Change Policy" },
      href: { tr: "/sustainability/climate-change-policy", en: "/sustainability/climate-change-policy" }
    },
    {
      name: { tr: "Yeşil Satın Alma Politikası", en: "Green Procurement Policy" },
      href: { tr: "/sustainability/green-purchasing", en: "/sustainability/green-purchasing" }
    },
    {
      name: { tr: "İş Sağlığı ve Güvenliği Politikası ve Faaliyetleri", en: "Energy Management Policy" },
      href: { tr: "/sustainability/occupational-health-and-safety-policy-and-activities", en: "/sustainability/occupational-health-and-safety-policy-and-activities" }
    },
    {
      name: { tr: "Sosyal Uygunluk Politikası", en: "Social Compliance Policy" },
      href: { tr: "/sustainability/social-compliance-policy", en: "/sustainability/social-compliance-policy" }
    },
    {
      name: { tr: "Modern Kölelik Politikası", en: "Modern Slavery Policy" },
      href: { tr: "/sustainability/modern-slavery-policy", en: "/sustainability/modern-slavery-policy" }
    },
    // {
    //   name: { tr: "Bilgilendirme ve Kamuyu Aydınlatma Politikası", en: "Disclosure Policy" },
    //   href: { tr: "/static/docs/policies/disclosure-tr.pdf", en: "/static/docs/policies/disclosure-en.pdf" }
    // },
    // { name: { tr: "Ücretlendirme Politikası", en: "Remuneration Policy" },
    //   href: { tr: "/static/docs/policies/remuneration-tr.pdf", en: "/static/docs/policies/remuneration-en.pdf" } },
    // { name: { tr: "Bağış ve Yardım Politikası", en: "Donation & Aid Policy" },
    //   href: { tr: "/static/docs/policies/donation-tr.pdf", en: "/static/docs/policies/donation-en.pdf" } },
    // { name: { tr: "Kar Dağıtım Politikası", en: "Dividend Policy" },
    //   href: { tr: "/static/docs/policies/dividend-tr.pdf", en: "/static/docs/policies/dividend-en.pdf" } },
    // { name: { tr: "Tazminat Politikası", en: "Compensation Policy" },
    //   href: { tr: "/static/docs/policies/compensation-tr.pdf", en: "/static/docs/policies/compensation-en.pdf" } },
    // { name: { tr: "Toplumsal Cinsiyet Eşitliği Politikası", en: "Gender Equality Policy" },
    //   href: { tr: "/static/docs/policies/gender-tr.pdf", en: "/static/docs/policies/gender-en.pdf" } },
    // { name: { tr: "İnsan Hakları Politikası", en: "Human Rights Policy" },
    //   href: { tr: "/static/docs/policies/human-rights-tr.pdf", en: "/static/docs/policies/human-rights-en.pdf" } },
    // { name: { tr: "Rekabet Hukuku Uyum Politikası", en: "Competition Compliance Policy" },
    //   href: { tr: "/static/docs/policies/competition-tr.pdf", en: "/static/docs/policies/competition-en.pdf" } },
    // { name: { tr: "Bilgi Güvenliği Politikası", en: "Information Security Policy" },
    //   href: { tr: "/static/docs/policies/infosec-tr.pdf", en: "/static/docs/policies/infosec-en.pdf" } },
    // { name: { tr: "Etik Davranış Kuralları", en: "Code of Ethics" },
    //   href: { tr: "/static/docs/policies/ethics-tr.pdf", en: "/static/docs/policies/ethics-en.pdf" } },
    // { name: { tr: "Çevre ve Enerji Politikası", en: "Environment & Energy Policy" },
    //   href: { tr: "/static/docs/policies/environment-tr.pdf", en: "/static/docs/policies/environment-en.pdf" } },
    // { name: { tr: "İş Sağlığı ve Güvenliği Politikası", en: "OHS Policy" },
    //   href: { tr: "/static/docs/policies/ohs-tr.pdf", en: "/static/docs/policies/ohs-en.pdf" } },
    // { name: { tr: "Sosyal Uygunluk Politikası", en: "Social Compliance Policy" },
    //   href: { tr: "/static/docs/policies/social-compliance-tr.pdf", en: "/static/docs/policies/social-compliance-en.pdf" } },
    // { name: { tr: "Modern Kölelik Politikası", en: "Modern Slavery Policy" },
    //   href: { tr: "/static/docs/policies/modern-slavery-tr.pdf", en: "/static/docs/policies/modern-slavery-en.pdf" } },
    // { name: { tr: "Kalite Politikası", en: "Quality Policy" },
    //   href: { tr: "/static/docs/policies/quality-tr.pdf", en: "/static/docs/policies/quality-en.pdf" } },
    // { name: { tr: "Yeşil Satın Alma Politikası", en: "Green Procurement Policy" },
    //   href: { tr: "/static/docs/policies/green-procurement-tr.pdf", en: "/static/docs/policies/green-procurement-en.pdf" } },
    // { name: { tr: "Tedarikçi Sürdürülebilirlik Politikası", en: "Supplier Sustainability Policy" },
    //   href: { tr: "/static/docs/policies/supplier-sustainability-tr.pdf", en: "/static/docs/policies/supplier-sustainability-en.pdf" } },
    // { name: { tr: "KVKK Çerçeve Politikası", en: "Data Protection (KVKK) Framework Policy" },
    //   href: { tr: "/static/docs/policies/kvkk-tr.pdf", en: "/static/docs/policies/kvkk-en.pdf" } },
  ];

  return (
    <div>
      <Meta
        title={t("policies")}
        description={t("policies")}
        lang={lang}
      />
      <Navbar />

      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("policies")}
              </h1>
            </div>
          </div>
        </div>

        {/* İçerik */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="pol-content">
            <section className="pol-card">
              <ul className="pol-list">
                {policies.map((p, i) => (
                  <li key={i} className="pol-row">
                    <span className="pol-title">{p.name[L] || p.name.en}</span>
                    <a
                      href={p.href[L] || p.href.en}
                      target="_blank"
                      rel="noreferrer"
                      className="pol-dl"
                      aria-label={(t("download") || "İndir") + ": " + (p.name[L] || p.name.en)}
                    >
                      {/* sadece ikon; dikey çizgi yok */}
                      {/* <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M12 3v12m0 0l4-4m-4 4l-4-4M5 21h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg> */}
                      <LuDownload size={18} />
                    </a>
                  </li>
                ))}
              </ul>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default PoliciesPage;
